import { Dimensions } from 'react-native';
import styled from 'styled-components/native';

export const Container = styled.ScrollView`
    height: ${Dimensions.get('screen').height - 360};
    border: solid transparent 0.5px;
    border-top-color: #bcbcbc;
`;
